export const SETTINGS_MENU = [
                                { 'main-title':'Profile Settings',
                                  'main-title-key':'profilesettings',        
                                   'disabled': false,
                                   'sub-titles': [{ key:'loginAndSecurity',
                                                   component:'LoginAndSecurityComponent',
                                                   name:' security',
                                                 }
                                                ]

                                }, 
                                { 'main-title':'Privacy', 
                                  'main-title-key':'privacy',  
                                  'disabled': false,
                                  'sub-titles': [{ key:'profileViewForOthers',
                                                   component:'YourProfileViewToOthersComponent',
                                                   name:'Your profile view to others'}
                                                ]

                                },
                                { 'main-title':'Video Call Settings', 
                                  'main-title-key':'videoCallSettings',  
                                  'disabled': false,
                                  'sub-titles': [{ key:'videoCallLink',
                                                   component:'VideoCallLinkComponent',
                                                   name:'videoCallLink'}
                                                ]

                                }
                           /*     { 'main-title':'Notifications',
                                    'main-title-key':  
                                    'disabled': true,
                                    'sub-titles': [{key:'',name:''}

                                               ]

                                },
                                { 'main-title':'Ads',
                                  'main-title-key':  
                                  'disabled': true,
                                  'sub-titles': [{key:'y',name:''}

                                               ]

                                },
                                { 'main-title':'Communications',
                                  'main-title-key':  
                                  'disabled': true,
                                  'sub-titles': [{key:'',name:''}

                                               ]
                                    
                                }
                                 */
                            ]
                            
export const frequencyAlertMenu = { 
    'main-title':'Documents Expiry Alerts', 
    'main-title-key':'documentsExpiryAlerts',  
    'disabled': false,
    'sub-titles': [{ key:'documentsExpiry',
                    component:'DocumentExpiryAlertSettingsComponent',
                    name:'Your profile view to others'}
                  ]
}